import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Immutable from 'immutable';
import { FormattedMessage } from 'react-intl';

import { bindAll } from '@bibliocommons/utils-react';
import { bibShape, shelfItemShape } from '@bibliocommons/bc-prop-types';
import BibScreenReaderDescription from 'app/components/shared/BibScreenReaderDescription';
import { CatalogueResultItemButton, CatalogueResultItemAlert } from 'app/components/shared/AddTitle/components';
import { Plus, Spinner } from '@bibliocommons/deprecated-base-icons';
import AddTitleContainer from 'app/components/shared/AddTitle/AddTitleContainer';
import BaseUGCEditor from '../BaseUGCEditor';
import ShelfPrivacyAlert from '../../ShelfPrivacyAlert';

import './SimilarTitlesUGCEditor.scss';

export class SimilarTitlesUGCEditor extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
    this.state = {
      setToPublic: false
    };
  }

  /*
  handleAddSuccess(data) {
    TODO: update once POST Request endpoint is working
  } */

  handlePrivacyToggle(setToPublic) {
    this.setState({ setToPublic });
  }

  handlePrivacySave() {
    const { setToPublic } = this.state;
    const { shelfItem, shelfActions } = this.props;

    if (shelfItem && shelfActions && setToPublic) {
      shelfActions.updateShelfItems({
        shelfName: shelfItem.get('shelf'),
        newShelfName: shelfItem.get('shelf'),
        shelfItemIds: [shelfItem.get('id')],
        metadataIds: [shelfItem.get('metadataId')],
        privateItem: false,
        postSuccess: this.props.handleClose
      });
    } else {
      this.props.handleClose();
    }
  }

  handleAdd(item) {
    // make api call
    return () => {
      const metadataId = this.props.bib.get('id');
      const similarTitleId = item.get('id');
      // TODO: pass in postSuccess method once endpoint is working
      this.props.similarTitlesActions.addSimilarTitle(metadataId, similarTitleId, () => null);
    };
  }

  renderAlert() {
    return this.props.shelfItem && this.props.shelfItem.get('privateItem') ? (
      <ShelfPrivacyAlert setToPublic={this.state.setToPublic} handleChange={this.handlePrivacyToggle} />
    ) : null;
  }

  renderScreenReaderMessage(item) {
    return (
      <FormattedMessage
        id="ada_label_add_similar_title_to_bib"
        values={{
          similarTitle: <BibScreenReaderDescription bibBrief={item} />,
          relatedBibTitle: this.props.bib.getIn(['briefInfo', 'title'])
        }}
      />
    );
  }

  renderAddOn(item) {
    const { bib, similarTitlesTransactions } = this.props;
    const transactionByMetaId = similarTitlesTransactions.get(bib.get('id'), Immutable.Map());
    if (transactionByMetaId.getIn([item.get('id'), 'isAdding'], false)) {
      // if item is between transction, show spinner
      return <Spinner />;
    }
    if (item.get('id') !== bib.get('id')) {
      // if item does not have same metadataId as current bib, render addOn view
      if (this.props.similarTitleBibs.keySeq().includes(item.get('id'))) {
        // if item exist in similar titles list, render the added icon
        return <CatalogueResultItemAlert label={<FormattedMessage id="added_to_shelf" />} />;
      }

      // else render the add button
      return (
        <CatalogueResultItemButton
          icon={<Plus />}
          label={<FormattedMessage id="add_to_shelf" />}
          item={item}
          screenReaderMessage={this.renderScreenReaderMessage(item)}
          handleClick={this.handleAdd(item)}
        />
      );
    }

    return null;
  }

  render() {
    const { bib, shelfItem, shelfActions, shelfTransactions } = this.props;

    const renderHeader = () => (
      <h2>
        <FormattedMessage id="add_similar_titles" />
      </h2>
    );

    return (
      <BaseUGCEditor
        bib={bib}
        className="cp-similar-title-ugc-editor"
        renderHeader={renderHeader}
        shelfItem={shelfItem}
        shelfTransactions={shelfTransactions}
        shelfActions={shelfActions}
      >
        <AddTitleContainer
          handleClose={this.handlePrivacySave}
          renderAddOn={this.renderAddOn}
          renderAlert={this.renderAlert}
          addRowClassNames={item => ({
            'current-bib': item.get('id') === bib.get('id')
          })}
        />
      </BaseUGCEditor>
    );
  }
}

SimilarTitlesUGCEditor.propTypes = {
  bib: bibShape.isRequired,
  shelfItem: shelfItemShape,
  handleClose: PropTypes.func.isRequired,
  similarTitleBibs: ImmutablePropTypes.map,
  similarTitlesTransactions: ImmutablePropTypes.map.isRequired,
  shelfTransactions: ImmutablePropTypes.map.isRequired,
  similarTitlesActions: PropTypes.objectOf(PropTypes.func).isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired
};

export default SimilarTitlesUGCEditor;
